import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { apiPost } from "../../../api";
import "../../../App.css";
import "../styles/ResetPassword.css";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [msg, setMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const passwordValid = {
    length: pass1.length >= 10 && pass1.length <= 20,
    letter: /[a-zA-Z]/.test(pass1),
    number: /\d/.test(pass1),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(pass1),
  };
  const allValid = Object.values(passwordValid).every(Boolean);
  const passwordsMatch = pass2.length > 0 && pass1 === pass2;

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setIsSuccess(false);
    setLoading(true);
    if (!allValid) {
      setMsg("Password does not meet requirements.");
      setIsSuccess(false);
      setLoading(false);
      return;
    }
    if (!passwordsMatch) {
      setMsg("Passwords do not match.");
      setIsSuccess(false);
      setLoading(false);
      return;
    }
    try {
      const res = await apiPost("/auth/reset-password", {
        token,
        password: pass1,
      });
      setMsg(res.message);
      setIsSuccess(true);
    } catch (err) {
      setMsg(err.message || "Error resetting password");
      setIsSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-box">
        <h2 className="reset-title">Reset Password</h2>

        <form onSubmit={onSubmit} className="reset-form">
          <label>New Password</label>
          <input
            type="password"
            value={pass1}
            onChange={(e) => setPass1(e.target.value)}
          />

          <ul className="password-checks">
            <li className={passwordValid.length ? "ok" : "bad"}>
              {passwordValid.length ? "✓" : "✖"} 10–20 characters
            </li>
            <li className={passwordValid.letter ? "ok" : "bad"}>
              {passwordValid.letter ? "✓" : "✖"} At least one letter
            </li>
            <li className={passwordValid.number ? "ok" : "bad"}>
              {passwordValid.number ? "✓" : "✖"} At least one number
            </li>
            <li className={passwordValid.special ? "ok" : "bad"}>
              {passwordValid.special ? "✓" : "✖"} At least one special
              character (e.g. !@#$%)
            </li>
          </ul>

          <label>Confirm Password</label>
          <input
            type="password"
            value={pass2}
            onChange={(e) => setPass2(e.target.value)}
          />
          {pass2.length > 0 && (
            <p className={`match-msg ${passwordsMatch ? "ok" : "bad"}`}>
              {passwordsMatch
                ? "Passwords match ✓"
                : "Passwords do not match ✖"}
            </p>
          )}

          <button type="submit" className="primary-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : "Reset Password"}
          </button>
        </form>

        {msg && <p className={`msg ${isSuccess ? "success" : "error"}`}>{msg}</p>}

        <div className="reset-links">
          <Link to="/auth/react/signin" className="link">
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}